import React, { useEffect, useState } from "react";
import "./ViewTuResult.scss";
import { BASE_URL } from "../../utils/config";
import { adminRequest } from "../../utils/requestMethods";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ViewTuResult = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  const [formData, setFormData] = useState({
    course: { id: "", short_name: "" },
    semester: "",
    rollNo: "",
  });

  const [courseList, setCourseList] = useState([]);
  const [semesterList, setSemesterList] = useState([]);
  const [result, setResult] = useState(null);
  const [isMultipleResult, setIsMultipleResult] = useState(false);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await adminRequest.get(`${BASE_URL}/course/getNameAndId`);
        setCourseList(res.data.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchCourses();
  }, []);

  useEffect(() => {
    if (formData.course.id) {
      const fetchSemesters = async () => {
        try {
          const res = await adminRequest.post(
            `${BASE_URL}/course/getSemestersById`,
            {
              id: formData.course.id,
            },
          );
          setSemesterList(res.data.data);
        } catch (err) {
          console.error(err);
        }
      };
      fetchSemesters();
    }
  }, [formData.course.id]);

  const handleCourseChange = (e) => {
    const selectedId = e.target.value;
    const selectedCourse = courseList.find(
      (c) => c.id === parseInt(selectedId),
    );
    if (selectedCourse) {
      setFormData({
        ...formData,
        course: {
          id: selectedCourse.id,
          short_name: selectedCourse.short_name,
        },
        semester: "",
      });
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    if (e?.preventDefault) e.preventDefault();

    const { course, semester, rollNo } = formData;

    try {
      const endpoint = rollNo.trim()
        ? `${BASE_URL}/query/tuResult/get`
        : `${BASE_URL}/query/tuResult/getAll`;

      const params = rollNo.trim()
        ? { course: course.short_name, semester, rollNo }
        : { course: course.short_name, semester };

      const response = await toast.promise(
        adminRequest.get(endpoint, { params }),
        { pending: "Processing your request..." },
      );

      setResult(response.data.data);
      setIsMultipleResult(!rollNo.trim());
    } catch (error) {
      toast.error(error.response?.data?.message);
      setResult([]);
    }
  };

  return (
    <div className="view-turesult-container full-page">
      <div className="top">
        <span className="backIcon" onClick={handleBackClick}>
          <FaArrowLeftLong />
        </span>
        <span className="headerTitle">View TU Result</span>
      </div>
      <form
        onSubmit={handleSubmit}
        className="form-row"
        style={{ display: "flex", gap: "20px", alignItems: "flex-end" }}
      >
        <div className="form-group">
          <label>Course</label>
          <select value={formData.course.id} onChange={handleCourseChange}>
            <option value="">Select Course</option>
            {courseList.map((c) => (
              <option key={c.id} value={c.id}>
                {c.short_name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Semester</label>
          <select
            name="semester"
            value={formData.semester}
            onChange={handleInputChange}
          >
            <option value="">Select Semester</option>
            {semesterList.map((s) => (
              <option key={s.semester} value={s.semester}>
                {s.semester}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Symbol Number (Optional)</label>
          <input
            type="text"
            name="rollNo"
            value={formData.rollNo}
            onChange={handleInputChange}
            placeholder="10333 / 29"
          />
        </div>

        <button type="submit" style={{ height: "38px", padding: "0 20px" }}>
          Search
        </button>
      </form>

      {result && result.length > 0 && !isMultipleResult && (
        <div className="tu-result-table">
          <div className="result-meta">
            <span>
              <strong>Name:</strong> {result[0].Student_Name}
            </span>
            <span>
              <strong>Symbol Number:</strong> {result[0].Symbol_Number}
            </span>
            <span>
              <strong>Registration No:</strong> {result[0].tu_redg_no || "N/A"}
            </span>
          </div>

          <table>
            <thead>
              <tr>
                <th>Subject</th>
                <th>GPA</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(result[0])
                .filter(([key]) => key.endsWith("_GPA"))
                .map(([gpaKey, gpaValue], index) => {
                  const subject = gpaKey
                    .replace(/_GPA$/, "")
                    .replace(/_/g, " ");
                  const gradeKey = gpaKey.replace("_GPA", "_Grade");
                  const grade = result[0][gradeKey] || "N/A";

                  return (
                    <tr key={index}>
                      <td>{subject}</td>
                      <td>{gpaValue}</td>
                      <td>{grade}</td>
                    </tr>
                  );
                })}
              <tr>
                <td>
                  <strong>SGPA</strong>
                </td>
                <td colSpan="2">{result[0].SGPA || "N/A"}</td>
              </tr>
              <tr>
                <td>
                  <strong>Remarks</strong>
                </td>
                <td colSpan="2">{result[0].Remarks || "N/A"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {result && result.length > 0 && isMultipleResult && (
        <div className="multi-result-table">
          <table>
            <thead>
              <tr>
                <th rowSpan="2">Symbol Number</th>
                <th rowSpan="2">Name</th>
                <th rowSpan="2">Regd. No</th>

                {Object.keys(result[0])
                  .filter((key) => key.endsWith("_GPA"))
                  .map((gpaKey, index) => {
                    const subject = gpaKey
                      .replace(/_GPA$/, "")
                      .replace(/_/g, " ");
                    return (
                      <th key={index} colSpan="2">
                        {subject}
                      </th>
                    );
                  })}

                <th rowSpan="2">SGPA</th>
                <th rowSpan="2">Remarks</th>
              </tr>
              <tr>
                {Object.keys(result[0])
                  .filter((key) => key.endsWith("_GPA"))
                  .map((_, index) => (
                    <React.Fragment key={index}>
                      <th>GPA</th>
                      <th>Grade</th>
                    </React.Fragment>
                  ))}
              </tr>
            </thead>

            <tbody>
              {result.map((student, i) => (
                <tr key={i}>
                  <td>{student.Symbol_Number}</td>
                  <td>{student.Student_Name}</td>
                  <td>{student.tu_redg_no || "N/A"}</td>

                  {Object.keys(student)
                    .filter((key) => key.endsWith("_GPA"))
                    .map((gpaKey, index) => {
                      const gradeKey = gpaKey.replace("_GPA", "_Grade");
                      return (
                        <React.Fragment key={index}>
                          <td>{student[gpaKey]}</td>
                          <td>{student[gradeKey]}</td>
                        </React.Fragment>
                      );
                    })}
                  <td>{student.SGPA || "N/A"}</td>
                  <td>{student.Remarks || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {result && result.length === 0 && (
        <p style={{ marginTop: "10px" }}>No result found.</p>
      )}
    </div>
  );
};

export default ViewTuResult;
